// removed by extract-text-webpack-plugin
module.exports = {"announcement-news":"announcement-news","announcement-title":"announcement-title","view-all":"view-all","view-all-link":"view-all-link","announcement-item":"announcement-item","announcement-time":"announcement-time","time":"time","day":"day","description":"description","view-detail":"view-detail"};


//////////////////
// WEBPACK FOOTER
// ./components/partials/announcement-block/style.scss
// module id = ./components/partials/announcement-block/style.scss
// module chunks = 0